module.exports = __webpack_public_path__ + "img/arrow.c421cb32.svg";